<i18n>
  {
    "en": {
      "app-name": "EZMeals",
      "message": {
        "hello": "hello world"
      }
    },
    "zh-tw": {
      "app-name": "EZMeals",
      "message": {
        "hello": "chinese hello"
      }
    }
  }
</i18n>

<template>
  <f7-page>
    <f7-navbar :title="$t('app-name')"></f7-navbar>

    <f7-list>
      <template v-if="storeId">
        <f7-list-item :link="menuUrl" title="點餐" view="#main-view" reload-all panel-close></f7-list-item>
        <f7-list-item :link="`/stores/${storeId}/history`" title="點餐記錄/取餐" view="#main-view" reload-all panel-close></f7-list-item>
        <f7-list-item :link="`/stores/${storeId}/about`" title="關於商家" view="#main-view" reload-all panel-close></f7-list-item>
        <f7-list-item :link="`/stores/${storeId}/info`" title="資訊" view="#main-view" reload-all panel-close></f7-list-item>
      </template>
    </f7-list>
    {{ buildVersion }}
  </f7-page>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
export default {
  dependencies: ['platformUtils'],
  computed: {
    ...mapState(['menuUrl', 'menuVariation']),
    ...mapGetters(['storeId']),
    buildVersion () {
      return process.env.NODE_ENV === 'production' ? '' : '非正式版'
    }
  },
  methods: {
  }
}
</script>
